<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem dos Perfis de Acesso.</span>
                <br/>
                <span class="navigation">Cadastros > Perfil de Acesso</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button
                  label="Pesquisar"
                  title="Pesquisar"
                  icon="pi pi-search"
                  :disabled="search"
                  @click="pesquisar()"
                />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button
                  label="Limpar"
                  title="Limpar"
                  icon="pi pi-trash"
                  :disabled="search"
                  @click="clear()"
                />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable :value="perfilList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true" >
              <Column headerStyle="width: 8em" header="Selecionar" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button
                    type="button"
                    title="Selecionar"
                    icon="pi pi-check"
                    :disabled="admin === 'N'"
                    style="margin-right: .5em"
                    @click="detail(slotProps.data.id, slotProps.data.nome)"
                  ></Button>
                </template>
              </Column>
              <Column field="nome" header="Nome"></Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import PerfilService from "../services/nfse/perfil.service";

export default {
  name: "perfilAcesso",
  data() {
    return {
      display: false,
      search: false,
      currentUser: null,
      filtro: "",
      perfilList: [],
      perfilId: null,
      admin: 'N'
    };
  },
  created() {
    this.admin = (this.$route.query.admin != null && this.$route.query.admin != '' ? this.$route.query.admin : 'N');
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods: {
    clear(){
      this.filtro = '';
      this.pesquisar();
    },
    pesquisar() {
      this.search = true;
      PerfilService.findAllByFiltro(this.currentUser.usuario.idCliente, this.filtro).then(
        perfil => {
          this.perfilList = perfil.data;
        },
        error => {
          let errorMessage = "Houve um problema listar Perfis!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(perfilId, nome) {
      this.$router.push({ name: "perfilAcessoCadastro", params: { id: perfilId, nome:  nome} });
    }
  }
};
</script>

<style scoped>
</style>